module.exports = __webpack_public_path__ + "static/media/Picture69.12e5be26.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture69.png
// module id = 1557
// module chunks = 0